import {getLanguageTitle} from '@hconnect/common/utils/language.util'
import {Box, Fade, makeStyles, Menu, MenuItem, Theme, useMediaQuery} from '@material-ui/core'
import {toUpper} from 'lodash'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {svgFlagSources} from '../../../common'

import {Flag} from './Flag'

const useStyles = makeStyles({
  hideIcon: {
    display: 'none'
  },
  popoverPaper: {
    width: '100%'
  }
})

interface Props {
  availableLanguages: string[]
  selectLanguage: (languageCode: string) => void
  currentLanguage: string
  country?: string
}

export const LanguagePicker = ({
  availableLanguages,
  currentLanguage,
  country,
  selectLanguage
}: Props) => {
  const classes = useStyles()
  const {t} = useTranslation()

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const isWideScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'))

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (language: string) => {
    handleClose()
    selectLanguage(language)
  }

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        onClick={handleClick}
        style={{cursor: 'pointer'}}
        data-test-id={`displayed-language-${currentLanguage}`}
      >
        <Flag
          country={
            svgFlagSources[toUpper(currentLanguage)]
              ? currentLanguage.toUpperCase() === 'SV'
                ? 'SE'
                : currentLanguage
              : country
          }
        />
        {isWideScreen ? (
          <span style={{marginLeft: '10px'}}>
            {getLanguageTitle(currentLanguage, country) || t(`language.${currentLanguage}`)}
          </span>
        ) : null}
      </Box>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        PopoverClasses={{paper: isWideScreen ? undefined : classes.popoverPaper}}
      >
        {availableLanguages.map((language, index) => (
          <MenuItem
            value={language}
            key={index}
            onClick={() => handleSelect(language)}
            data-test-id={`language-item-${language}`}
          >
            <Box display="flex" alignItems="center">
              <Flag
                country={
                  svgFlagSources[toUpper(language)]
                    ? language.toUpperCase() === 'SV'
                      ? 'SE'
                      : language
                    : country
                }
              />
              <span style={{marginLeft: '10px'}}>
                {getLanguageTitle(language, country) || t(`language.${language}`)}
              </span>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  )
}
